import { useEffect, useRef, useState } from 'react'

import { EMPTY_LIST } from '../../../../../constants/common'
import { useSelection } from '../../../../../hooks'
import { useLocationPagination } from '../../../../Pagination'
import { getRentalPortalArchiveItems } from '../../RentalPortalArchive.api'
import { getRentalPortalArchivePage } from '../../RentalPortalArchive.utils'

export function useRentalPortalArchiveTable() {
  const { pagination: locationPagination, setPagination } =
    useLocationPagination()

  const [reloadKey, setReloadKey] = useState(0)

  const [allItems, setAllItems] = useState(EMPTY_LIST)
  const [serverError, setServerError] = useState(null)

  const [isInitiated, setInitiated] = useState(false)
  const [isLoadingItems, setLoadingItems] = useState(true)

  const readIdRef = useRef(0)

  const pageScrollWrapperRef = useRef(null)

  const { items, pagination } = getRentalPortalArchivePage({
    allItems,
    page: locationPagination.page,
  })

  const selection = useSelection({ data: { items }, pagination })

  useEffect(() => {
    readIdRef.current += 1

    const readId = readIdRef.current

    // eslint-disable-next-line react-hooks/set-state-in-effect -- the read's own in-flight flag flips when the read starts, like `useTableLoader` does
    setLoadingItems(true)

    getRentalPortalArchiveItems()
      .then(nextItems => {
        if (readIdRef.current === readId) {
          setAllItems(nextItems)
          setServerError(null)
        }
      })
      .catch(error => {
        if (readIdRef.current === readId) {
          setServerError(error)
        }
      })
      .finally(() => {
        if (readIdRef.current === readId) {
          setLoadingItems(false)
          setInitiated(true)
        }
      })
  }, [reloadKey])

  async function handleRefresh() {
    selection.handleCleanSelection()

    setReloadKey(prevReloadKey => prevReloadKey + 1)
  }

  return {
    ...selection,
    allItems,
    handleRefresh,
    handleSetPagination: setPagination,
    isLoading: !isInitiated,
    isRefetching: isLoadingItems && isInitiated,
    items,
    pageScrollWrapperRef,
    pagination,
    serverError,
  }
}
